import * as t from "io-ts";

export const UnitTypeV = t.union([
  // Absolute length units
  t.literal("cm"),
  t.literal("mm"),
  t.literal("in"),
  t.literal("pc"),
  t.literal("pt"),
  t.literal("px"),

  // Relative length units
  t.literal("em"),
  t.literal("rem"),
  t.literal("%"),

  // Viewport-percentage lengths
  t.literal("vw"),
  t.literal("vh"),
  t.literal("vmin"),
  t.literal("vmax"),

  // Time units
  t.literal("s"),
  t.literal("ms"),

  // Other
  t.literal("deg"),
  t.literal("calc"),
  t.literal("auto"),
  t.literal("custom")
]);

export const UNIT_TYPES: UnitType[] = UnitTypeV.types.map(({ value }) => value);

export type UnitType = t.TypeOf<typeof UnitTypeV>;

export const UnitNumberV = t.union([t.string, t.number, t.undefined, t.null]);
export type UnitNumber = t.TypeOf<typeof UnitNumberV>;

export const UnitInputValueV = t.union([
  t.type({
    number: UnitNumberV,
    unit: UnitTypeV,
    style: t.union([t.string, t.literal(0)])
  }),
  t.null
]);

export type UnitInputValue = t.TypeOf<typeof UnitInputValueV>;

export const UnitOptionsV = t.partial({
  types: t.union([t.array(UnitTypeV), t.undefined, t.null]),
  defaultType: t.union([UnitTypeV, t.undefined])
});

export type UnitOptions = t.TypeOf<typeof UnitOptionsV>;

export const DEFAULT_UNIT_TYPES: UnitType[] = [
  "px",
  "%",
  "em",
  "rem",
  "vw",
  "vh",
  "auto",
  "custom"
];
